import type { Site } from '@hotjar/site';
import { useQueryParameter } from '@hotjar/webapp/hooks/useQueryParameter';
import { setSurveyTemplateIdToAppState } from '@hotjar/webapp/features/Surveys/Templates';

type UserId = Parameters<typeof setSurveyTemplateIdToAppState>[0];

interface SurveyTemplate {
  preserveTemplateId: (user: { id: UserId }, site: Site) => void;
  surveyTemplateId?: string;
}

export const useSurveyTemplate = (): SurveyTemplate => {
  const surveyTemplateId = useQueryParameter('survey_template_id');

  return {
    surveyTemplateId,
    preserveTemplateId: (user: { id: UserId }, site: Site) => {
      if (surveyTemplateId) {
        return setSurveyTemplateIdToAppState(user.id, site.id, surveyTemplateId);
      }
      return Promise.resolve();
    },
  };
};
